import { Box, Button, Flex, Heading, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { OrderSection } from './dashboard/components/DashboardStyles';
import { backbtn } from './dashboard/components/Icons';
import barcode from '../assets/barCode.png';
import { dummyList } from '../dummyData/dummyData';
import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';

const TransHistory = () => {
    const navigate = useNavigate();
    let { id } = useParams();
    const result = dummyList?.filter((list) => list.id === Number(id))[0];
    return (
        <OrderSection>
            <HStack
                justify="space-between"
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}
                alignItems="center"
                mt="27px"
                w="90vw"
                mx="auto">
                <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                <div className="menuSection"></div>
                <div></div>
            </HStack>
            <Box
                mx="auto"
                w={{ base: '90vw', lg: '45%' }}
                bg={{ base: 'none', lg: 'white' }}
                p={{ base: '0', lg: '15px 30px' }}
                boxShadow={{ base: 'none', lg: '0px 4px 33px rgba(0, 0, 0, 0.03)' }}>
                <Heading color="#090A0A" lineHeight="36px" fontSize="32px" mt="20px" mb="5px">
                    Transaction History
                </Heading>
                <Box textAlign="center" py="5px">
                    <Image src={barcode} />
                </Box>

                <HStack my="20px" justify="space-between" px="1rem">
                    <Flex>
                        <Image src={result.image} mr="16px" w="40px" h="40px" borderRadius="50%" />
                        <Box>
                            <Text fontSize="14px">{result.prodName}</Text>
                            <Text color="#878787" fontSize="14px">
                                Dec 15, 2014
                            </Text>
                        </Box>
                    </Flex>
                    <Box textAlign="right">
                        <Text>₦{result.price}</Text>
                        <Flex alignItems="center">
                            <Text fontSize="14px" mr="5px" color="#878787">
                                Orders
                            </Text>
                            <Box bg="#359507" w="10px" h="10px" borderRadius="4px"></Box>
                        </Flex>
                    </Box>
                </HStack>

                <VStack w="full" pt="50px" pb="20px" px="1rem" gap="12px">
                    <HStack w="full" justifyContent="space-between">
                        <Text fontWeight="500">Amount</Text> <Text>₦{result.price}.00</Text>
                    </HStack>
                    <HStack
                        w="full"
                        justifyContent="space-between"
                        borderBottom="1px solid #0000001a"
                        pb="1rem">
                        <Text fontWeight="500">Promo</Text> <Text>₦{result.price}.00</Text>
                    </HStack>
                    <HStack w="full" justifyContent="space-between">
                        <Text fontWeight="500">Price</Text> <Text>₦{result.price}.00</Text>
                    </HStack>
                </VStack>

                <VStack w="full" pt="40px" pb="30px" px="1rem" gap="12px">
                    <HStack w="full" justifyContent="space-between">
                        <Text fontWeight="500">Payment Methods</Text> <Text>My E-Wallet</Text>
                    </HStack>
                    <HStack w="full" justifyContent="space-between">
                        <Text fontWeight="500">Date</Text> <Text>Dec 15, 2024</Text>
                    </HStack>

                    <HStack w="full" justifyContent="space-between">
                        <Text fontWeight="500">Transaction ID</Text> <Text>SK684854738</Text>
                    </HStack>
                </VStack>

                <Box
                    w={{ base: '65%', lg: '100%' }}
                    mx="auto"
                    display={{ lg: 'flex', base: 'block' }}
                    gap="20px">
                    <Button
                        color="#F5F5F5"
                        w="100%"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            navigate(`/dashboard/orders/true`, { replace: true });
                        }}>
                        Go to My Order
                    </Button>
                    <Button
                        w="100%"
                        color="#1E1E1E"
                        border="1px solid black"
                        bg="white"
                        mt="15px"
                        mb="5rem"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            navigate(`/dashboard`, { replace: true });
                        }}>
                        Go to Dashboard
                    </Button>
                </Box>
            </Box>
        </OrderSection>
    );
};

export default TransHistory;
